export default "__VITE_ASSET__DrpHbD7u__"